<template>
  <div class="sales-order-detail">
    <div class="detail-header">
      <el-button type="primary" size="small" circle @click="goBack">
        <i class="el-icon-back" />
      </el-button>
      <h2>销售单详情</h2>
    </div>

    <!-- 基础信息板块 -->
    <div class="section">
      <div class="section-header">
        <h3>基础信息</h3>
      </div>
      <div class="section-content">
        <!-- PC端基础信息 -->
        <div class="pc-basic-info">
          <div class="basic-info-grid">
            <div class="basic-info-item">
              <span class="label">销售单号：</span>
              <span class="value">{{ orderDetail.saleNumber }}</span>
            </div>
            <div class="basic-info-item">
              <span class="label">销售类型：</span>
              <span class="value">{{
                orderDetail.saleType === '1' ? '批发' : '零售'
              }}</span>
            </div>
            <div class="basic-info-item">
              <span class="label">出库仓库：</span>
              <span class="value">{{ orderDetail.wareName || '' }}</span>
            </div>
            <div class="basic-info-item">
              <span class="label">客户：</span>
              <span class="value">{{ orderDetail.supplierName || '-' }}</span>
            </div>
            <div class="basic-info-item">
              <span class="label">分销员：</span>
              <span class="value">{{ orderDetail.wealthName || '-' }}</span>
            </div>
          </div>
        </div>

        <!-- 移动端基础信息卡片 -->
        <div class="mobile-card">
          <div class="card-item">
            <span class="label">销售单号</span>
            <span class="value">{{ orderDetail.saleNumber || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">销售类型</span>
            <span class="value">{{
              orderDetail.saleType === '1' ? '批发' : '零售'
            }}</span>
          </div>
          <div class="card-item">
            <span class="label">出库仓库</span>
            <span class="value">{{ orderDetail.wareName || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">客户</span>
            <span class="value">{{ orderDetail.supplierName || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">分销员</span>
            <span class="value">{{ orderDetail.wealthName || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品列表板块 -->
    <div class="section">
      <div class="section-header">
        <h3>商品列表</h3>
      </div>
      <div class="section-content">
        <!-- PC端商品表格 -->
        <div class="pc-product-table">
          <el-table :data="products" stripe size="small" class="product-table">
            <el-table-column
              prop="index"
              label="序号"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="productName"
              label="商品名称"
              min-width="180"
              align="center"
            />
            <el-table-column
              prop="productSkuAttrValue"
              label="规格"
              min-width="100"
              align="center"
            />
            <el-table-column
              prop="productNum"
              label="数量"
              width="120"
              align="center"
            />
            <el-table-column
              prop="unitPrice"
              label="单价"
              width="100"
              align="center"
            />
            <el-table-column
              prop="actualPrice"
              label="金额"
              width="100"
              align="center"
            />
            <el-table-column
              prop="productSkuBarCode"
              label="条形码"
              min-width="150"
              align="center"
            />
          </el-table>

          <!-- 总计行 -->
          <div class="total-row">
            <div class="total-label">总计</div>
            <div class="total-empty" />
            <div class="total-empty" />
            <div class="total-quantity">{{ totalQuantity }}</div>
            <div class="total-empty" />
            <div class="total-amount">{{ totalAmount }}</div>
            <div class="total-empty" />
          </div>
        </div>

        <!-- 移动端商品卡片 -->
        <div class="mobile-product-cards">
          <div
            v-for="(product, index) in products"
            :key="index"
            class="mobile-product-card"
          >
            <div class="product-header">
              <div class="product-index">序号：{{ index + 1 }}</div>
              <div class="product-barcode">
                条形码：{{ product.productSkuBarCode }}
              </div>
            </div>
            <div class="product-info">
              <div class="product-name">{{ product.productName }}</div>
              <div class="product-spec">{{ product.productSkuAttrValue }}</div>
              <div class="product-price-row">
                <div class="product-quantity">
                  数量：{{ product.productNum }}
                </div>
                <div class="product-price">单价：{{ product.unitPrice }}</div>
                <div class="product-amount">
                  金额：{{ product.actualPrice }}
                </div>
              </div>
            </div>
          </div>

          <!-- 移动端总计 -->
          <div class="mobile-total">
            <div class="mobile-total-label">总计</div>
            <div class="mobile-total-content">
              <div class="mobile-total-item">
                <span class="label">总数量：</span>
                <span class="value">{{ totalQuantity }}</span>
              </div>
              <div class="mobile-total-item">
                <span class="label">总金额：</span>
                <span class="value">{{ totalAmount }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 其他信息板块 -->
    <div class="section">
      <div class="section-header">
        <h3>其他信息</h3>
      </div>
      <div class="section-content">
        <!-- PC端其他信息 -->
        <div class="pc-other-info">
          <!-- 制单和审核信息 -->
          <div class="document-info">
            <div class="document-item">
              <span class="label">制单：</span>
              <span
                class="value"
              >{{ orderDetail.createBy || '' }}
                {{ orderDetail.createTime || '' }}</span>
            </div>
            <div class="document-item">
              <span class="label">审核：</span>
              <span
                class="value"
              >{{ orderDetail.auditBy || '' }}
                {{ orderDetail.auditTime || '' }}</span>
            </div>
          </div>

          <!-- 状态信息 -->
          <div class="status-info">
            <div class="status-item">
              <span class="label">出库状态：</span>
              <span class="value">{{
                orderDetail.outStorageState | formatOutStorageState
              }}</span>
            </div>
            <div class="status-item">
              <span class="label">收款状态：</span>
              <span class="value">{{
                orderDetail.receiptState | formatReceiptState
              }}</span>
            </div>
          </div>

          <!-- 收货人信息 -->
          <div class="consignee-info">
            <div class="consignee-item">
              <span class="label">收货人：</span>
              <span class="value">{{ orderDetail.contactPerson || '' }}</span>
            </div>
            <div class="consignee-item">
              <span class="label">手机号：</span>
              <span class="value">{{ orderDetail.contactPhone || '' }}</span>
            </div>
            <div class="consignee-item full-width">
              <span class="label">收货地址：</span>
              <span class="value">{{ orderDetail.contactAddress || '' }}</span>
            </div>
          </div>
        </div>

        <!-- 移动端其他信息卡片 -->
        <div class="mobile-card">
          <!-- 制单和审核信息 -->
          <div class="mobile-document-info">
            <div class="card-subtitle">制单信息</div>
            <div class="card-item">
              <span class="label">制单</span>
              <span
                class="value"
              >{{ orderDetail.createBy || '' }}
                {{ orderDetail.createTime || '' }}</span>
            </div>
            <div class="card-item">
              <span class="label">审核</span>
              <span
                class="value"
              >{{ orderDetail.auditBy || '' }}
                {{ orderDetail.auditTime || '' }}</span>
            </div>
          </div>

          <!-- 状态信息 -->
          <div class="mobile-status-info">
            <div class="card-subtitle">状态信息</div>
            <div class="card-item">
              <span class="label">出库状态</span>
              <span class="value">{{
                orderDetail.outStorageState | formatOutStorageState
              }}</span>
            </div>
            <div class="card-item">
              <span class="label">收款状态</span>
              <span class="value">{{
                orderDetail.receiptState | formatReceiptState
              }}</span>
            </div>
          </div>

          <!-- 收货人信息 -->
          <div class="mobile-consignee-info">
            <div class="card-subtitle">收货人信息</div>
            <div class="card-item">
              <span class="label">收货人</span>
              <span class="value">{{ orderDetail.contactPerson || '' }}</span>
            </div>
            <div class="card-item">
              <span class="label">手机号</span>
              <span class="value">{{ orderDetail.contactPhone || '' }}</span>
            </div>
            <div class="card-item">
              <span class="label">收货地址</span>
              <span class="value">{{ orderDetail.contactAddress || '' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api_getSaleStorageDetail } from '@/api/index';
export default {
  name: 'SalesOrderDetail',
  filters: {
    formatOutStorageState(val) {
      if (val === '0') {
        return '草稿';
      }
      if (val === '1') {
        return '待审核';
      }
      if (val === '2') {
        return '清点通过';
      }
      if (val === '3') {
        return '审核驳回';
      }
      if (val === '4') {
        return '同意出库';
      }
      return '-';
    },
    formatReceiptState(val) {
      if (val === '0') {
        return '草稿';
      }
      if (val === '1') {
        return '待审核';
      }
      if (val === '2') {
        return '审核通过';
      }
      if (val === '3') {
        return '审核驳回';
      }
      return '-';
    }
  },
  data() {
    return {
      orderDetail: {},
      products: []
    };
  },
  computed: {
    // 计算总数量
    totalQuantity() {
      let totalQuantity = 0;
      this.products.forEach((product) => {
        totalQuantity += Number(product.productNum);
      });
      return totalQuantity.toFixed(4);
    },
    // 计算总金额
    totalAmount() {
      let totalAmount = 0;
      this.products.forEach((product) => {
        totalAmount += Number(product.actualPrice);
      });
      return totalAmount.toFixed(4);
    }
  },
  created() {
    // 获取订单ID
    const orderId = this.$route.params.id;
    // 模拟获取订单详情
    this.getOrderDetail(orderId);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 模拟获取订单详情
    async getOrderDetail(orderId) {
      // 实际项目中，这里应该调用API获取订单详情
      console.log('获取销售单详情:', orderId);
      try {
        const res = await api_getSaleStorageDetail({
          id: orderId
        });
        this.orderDetail = res.data;
        this.products = res.data.saleProducts || [];
      } catch (error) {
        // this.$message.error(error.message || '获取销售单详情失败');
        console.error(error);
      }
    }
  }
};
</script>

<style scoped>
.sales-order-detail {
  padding: 20px;
}

.detail-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.sales-order-detail h2 {
  font-size: 24px;
  font-weight: bold;
  /* margin-bottom: 20px; */
  color: #333;
}

.sales-order-detail h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.section {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-header {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

/* PC端基础信息样式 */
.pc-basic-info {
  display: block;
}

.basic-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.basic-info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.basic-info-item .label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.basic-info-item .value {
  font-size: 14px;
  color: #333;
}

/* 商品列表样式 */
.pc-product-table {
  margin-top: 15px;
  position: relative;
}

.product-table {
  width: 100%;
  font-size: 14px;
}

/* 总计行样式 */
.total-row {
  display: grid;
  grid-template-columns: 80px 180px 100px 120px 100px 100px 150px;
  align-items: center;
  padding: 10px 15px;
  background-color: #f0f2f5;
  border: 1px solid #ebeef5;
  border-top: none;
  font-weight: bold;
  font-size: 14px;
}

.total-label {
  text-align: center;
  color: #333;
}

.total-quantity {
  text-align: center;
  color: #333;
}

.total-amount {
  text-align: center;
  color: #333;
}

.total-empty {
  /* 占位用 */
}

/* 其他信息样式 */
.pc-other-info {
  margin-top: 25px;
}

.document-info,
.status-info,
.consignee-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.consignee-info .full-width {
  grid-column: 1 / -1;
}

.document-item,
.status-item,
.consignee-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.document-item .label,
.status-item .label,
.consignee-item .label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.document-item .value,
.status-item .value,
.consignee-item .value {
  font-size: 14px;
  color: #333;
}

.consignee-item.full-width {
  justify-content: flex-start;
  gap: 15px;
}

/* 移动端卡片样式 */
.mobile-card {
  display: none;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
}

.card-item:last-child {
  border-bottom: none;
}

.card-item .label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.card-item .value {
  font-size: 14px;
  color: #333;
  text-align: right;
  flex: 1;
  margin-left: 15px;
}

.card-subtitle {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  padding: 15px 15px 8px;
  border-bottom: 1px solid #f0f0f0;
}

/* 移动端商品卡片 */
.mobile-product-cards {
  display: none;
  gap: 15px;
  margin-top: 15px;
}

.mobile-product-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 12px;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.product-index {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.product-barcode {
  font-size: 12px;
  color: #666;
}

.product-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
}

.product-spec {
  font-size: 12px;
  color: #666;
}

.product-price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  font-size: 14px;
  font-weight: bold;
}

.product-price {
  color: #5470c6;
}

.product-quantity {
  color: #333;
}

.product-amount {
  color: #f56c6c;
}

/* 移动端总计样式 */
.mobile-total {
  background-color: #f0f2f5;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px;
  margin-top: 15px;
}

.mobile-total-label {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.mobile-total-content {
  display: flex;
  justify-content: space-around;
  gap: 15px;
}

.mobile-total-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.mobile-total-item .label {
  font-size: 12px;
  color: #666;
}

.mobile-total-item .value {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sales-order-detail {
    padding: 15px;
  }

  .sales-order-detail h2 {
    font-size: 20px;
    /* margin-bottom: 15px; */
  }

  .sales-order-detail h3 {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .section {
    padding: 15px;
    margin-bottom: 15px;
  }

  /* 隐藏PC端表格，显示移动端卡片 */
  .pc-basic-info,
  .pc-product-table,
  .pc-other-info {
    display: none;
  }

  .mobile-card,
  .mobile-product-cards {
    display: block;
  }

  .basic-info-grid,
  .document-info,
  .status-info,
  .consignee-info {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .basic-info-item,
  .document-item,
  .status-item,
  .consignee-item {
    padding: 8px 12px;
  }

  .basic-info-item .label,
  .basic-info-item .value,
  .document-item .label,
  .document-item .value,
  .status-item .label,
  .status-item .value,
  .consignee-item .label,
  .consignee-item .value {
    font-size: 13px;
  }

  /* 移动端总计样式调整 */
  .total-row {
    grid-template-columns: 60px 120px 80px 100px 80px 80px 120px;
    font-size: 13px;
    padding: 8px 12px;
  }
}

@media (max-width: 480px) {
  .sales-order-detail {
    padding: 10px;
  }

  .section {
    padding: 12px;
  }

  .card-item {
    padding: 10px 12px;
  }

  .card-item .label,
  .card-item .value {
    font-size: 13px;
  }

  .mobile-product-card {
    padding: 10px;
  }

  .product-name {
    font-size: 13px;
  }

  .product-spec,
  .product-barcode {
    font-size: 11px;
  }

  .product-price-row {
    font-size: 13px;
  }
}
</style>
